const module = { name: 'mobile/searchAutocomplete/form/creation', exports: {} }; const exports = module.exports;



import { fd_url_manager as links } from 'require-core';



import { Fandango as Fandango_context } from 'require-core';

const { context: { featureFlags: { autocompleteEnabled } = {} } } = Fandango_context;


import { Fandango_adobeLaunch as adobeLaunch } from 'require-global';



import { Fandango_clearableInput as clearableInput } from 'require-core';



import { Fandango_overlay as overlay } from 'base-libraries';



import { default as searchAutocompleteFormEvents } from 'swug-fdRequire-call:mobile/searchAutocomplete/form/events';



const Selectors = {
    SEARCH_BTN: '#global-header__search-icon',
}


const Styles = {
    FD_CLEARABLE_INPUT: 'fd-clearable-input__input',
    SEARCH_AUTOCOMPLETE_CLOSE_BTN: 'search-autocomplete__close-btn',
    SEARCH_AUTOCOMPLETE_INPUT_BAR: 'search-autocomplete__input-bar',
    SEARCH_AUTOCOMPLETE_RESULTS: 'search-autocomplete__results',
    SEARCH_OVERLAY: 'search-overlay',
    FLOATING_LABEL: 'fd-floating-label',
    FLOATING_LABEL_ACTIVE: 'fd-floating-label--active',
    FLOATING_LABEL_LABEL: 'fd-floating-label__label',
}


const IDs = {
    AUTOCOMPLETE_SEARCH_RESULTS: 'autocomplete-search-results',
    AUTOCOMPLETE_SEARCH_INPUT: 'autocomplete-search-input',
    AUTOCOMPLETE_SEARCH_HINT: 'autocomplete-search-hint',
    AUTOCOMPLETE_SEARCH_STATUS: 'autocomplete-search-status',
}


const LABELS = {
    INPUT_LABEL: 'Search Films + Cinemas',
}
function makeInput() {
    const input = document.createElement('input');
    input.classList.add(Styles.FD_CLEARABLE_INPUT);
    input.id = IDs.AUTOCOMPLETE_SEARCH_INPUT;
    input.name = 'q';
    input.type = 'text';
    input.tabIndex = '1';
    input.setAttribute('aria-describedby', `${IDs.AUTOCOMPLETE_SEARCH_HINT} ${IDs.AUTOCOMPLETE_SEARCH_STATUS}`);
    return input;
}
function makeOutputContainer() {
    const output = document.createElement('div');
    output.classList.add(Styles.SEARCH_AUTOCOMPLETE_RESULTS);
    output.id = IDs.AUTOCOMPLETE_SEARCH_RESULTS;
    return output;
}
function makeForm(input) {
    const form = document.createElement('form');
    form.classList.add(Styles.SEARCH_AUTOCOMPLETE_INPUT_BAR);
    form.method = 'get';
    form.action = links.mwebSearch();
    const clearableInputMarkup = clearableInput.make(input, {
        isSearch: true,
        isModal: true,
        label: LABELS.INPUT_LABEL,
    });
    clearableInputMarkup.classList.add(Styles.FLOATING_LABEL);
    const label = document.createElement('label');
    label.classList.add(Styles.FLOATING_LABEL_LABEL);
    label.htmlFor = input.id;
    label.textContent = LABELS.INPUT_LABEL;
    clearableInputMarkup.appendChild(label);
    const updateFloatingLabelState = () => {
        const hasValue = ((input.value || '').trim().length > 0);
        const isFocused = document.activeElement === input;
        clearableInputMarkup.classList.toggle(Styles.FLOATING_LABEL_ACTIVE, hasValue || isFocused);
    };
    input.addEventListener('focus', updateFloatingLabelState);
    input.addEventListener('blur', updateFloatingLabelState);
    input.addEventListener('input', updateFloatingLabelState);
    updateFloatingLabelState();
    const hint = document.createElement('span');
    hint.id = IDs.AUTOCOMPLETE_SEARCH_HINT;
    hint.className = 'sr-only';
    hint.textContent = 'Suggestions will appear as you start typing.';
    form.appendChild(clearableInputMarkup);
    form.appendChild(hint);
    return form;
}
function onClick() {
    const input = makeInput();
    const form = makeForm(input);
    const status = document.createElement('span');
    status.id = IDs.AUTOCOMPLETE_SEARCH_STATUS;
    status.className = 'sr-only';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    form.appendChild(status);
    function onShow() {
        input.focus();
    }
    overlay.open(form, {
        onShow,
        noTimeout: true,
        closeBtnStyle: Styles.SEARCH_AUTOCOMPLETE_CLOSE_BTN,
        overlayStyle: Styles.SEARCH_OVERLAY,
    });
    const output = makeOutputContainer();
    form.after(output);
    searchAutocompleteFormEvents.init(input, output, { statusElement: status });
    adobeLaunch.track({
        event: adobeLaunch.EventTypes.INTERNAL_SEARCH_CLICK
    });
}
function init() {
    if (!autocompleteEnabled) {
        return;
    }
    const searchBtn = document.querySelector(Selectors.SEARCH_BTN);
    if (searchBtn) {
        searchBtn.addEventListener('click', onClick);
    }
}
module.exports = {
    init
};
export default module.exports;